import { apiClient } from "@/core/api/ApiClient";
import { EntityType, VisualInspectionDto } from "@/core/api/generated/v1";

import BaseEntitiesDeleteModal, {
  BaseEntitiesDeleteModalInheritableProps,
} from "../components/BaseEntitiesDeleteModal";

export interface OwnProps {
  entities: VisualInspectionDto[];
}

type Props = OwnProps & BaseEntitiesDeleteModalInheritableProps;

export default function VisualInspectionsDeleteModal({ entities, ...otherProps }: Props) {
  return (
    <BaseEntitiesDeleteModal
      cascadeActionDisplay={true}
      entityType={EntityType.VisualInspection}
      entities={entities}
      deleteFunc={async (params) => {
        await apiClient.visualInspectionsApi.apiV1VisualInspectionsBulkDeleteDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          entityBulkDeleteDto: {
            ids: params.entityIds,
            relatedEntitiesTypes: params.relatedEntitiesTypes,
          },
        });
      }}
      {...otherProps}
    />
  );
}
